import React from "react";
import { useParams } from "react-router";
import Query from "../common/Query";

import POST_QUERY from "./queries/POST_QUERY";
import NewsItem from "./components/NewsItem";
import Article from "./types/Article";

const NewsItemView = () => {
  let { id }: { id?: string } = useParams();
  return (
    <Query query={POST_QUERY} id={id}>
      {({ data: { post } }: { data: { post: Article } }) => {
        return <NewsItem article={post} standalone={true} />;
      }}
    </Query>
  );
};

export default NewsItemView;
